<template>
    <div v-loading="dataLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
        >
            <div class="page-group-title"><span>基础设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="活动名称:">
                        <el-input
                            v-model="formData.name"
                            placeholder="请填写活动名称"
                            :maxlength="20"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="datetimerange" label="活动有效期:">
                        <el-date-picker
                            v-model="formData.datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
			<el-row :gutter="30">
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="onTime" label="上线时间:" :rules='[{required: true, message: "请填写上线时间"}]'>
			            <el-date-picker type="datetime" v-model="formData.onTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<small><span class="el-icon-warning"></span>上线前乐迷端活动列表不展示该活动.</small>
			        </el-form-item>
			    </el-col>
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="offTime" label="下线时间:" :rules='[{required: true, message: "请填写下线时间"}]'>
			            <el-date-picker type="datetime" v-model="formData.offTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<small><span class="el-icon-warning"></span>下线后乐迷端活动列表不展示该活动.</small>
			        </el-form-item>
			    </el-col>
			</el-row>
			<el-row :gutter="40">
			    <el-col :xs="24" :sm="24" :xl="16">
			        <el-form-item prop="activityIdList" label="关联演出:">
			            <el-input v-model="activityParams.activityId" class="input-with-select"  :placeholder="activityParams.type == 1 ? '请输入演出ID' : '请输入巡演ID'" size="medium">
			                <el-select
			                    v-model="activityParams.type"
			                    slot="prepend"
			                    placeholder="请选择"
			                >
			                    <el-option label="演出ID" :value="1"></el-option>
			                    <el-option label="巡演ID" :value="2"></el-option>
			                </el-select>
			                <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
			            </el-input>
			            <small class="from-tip"><span class="el-icon-warning"></span> 通过ID查询并绑定相关演出</small>
			            <el-table
			                v-if="activities && activities.length > 0"
			                :data="activities"
			                border
			                style="width: 100%"
			                size="small"
			            >
			                <el-table-column prop="id" label="演出ID"></el-table-column>
			                <el-table-column prop="name" label="演出名称"></el-table-column>
			                <el-table-column fixed="right" label="操作" width="80">
			                    <template slot-scope="scope">
			                        <el-button
			                            type="text"
			                            size="small"
			                            icon="el-icon-delete"
			                            @click="delActivity(scope.row)"
			                            >删除</el-button
			                        >
			                    </template>
			                </el-table-column>
			            </el-table>
			        </el-form-item>
			    </el-col>
			</el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="poster" label="活动封面:">
                        <image-upload 
                            :url.sync="formData.poster" 
                            :urlFull.sync="formData.poster" 
                            :crop="true"
                            :width="650"
                            :height="350"
                            ref="posterUpload"
                            class="poster-upload"
                            @onSuccess="handleImageSuccess"
                        >
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="countDown" label="膨胀活动时效:" :rules="[{ required: formData.countDownType == 1 ? true : false, message: '请填写时效限制' }]" :show-message="formData.countDownType == 1 ? true : false">
                        <el-radio v-model="formData.countDownType" :label="0">无时效限制</el-radio>
                        <div><small class="color-info">无时效限制，以<span class="color-danger">活动时间段</span>为准，用户在此时间段都可以发起/参与膨胀活动</small></div>
                        <el-radio v-model="formData.countDownType" :label="1">有时效限制</el-radio>
                        <div v-if="formData.countDownType">
                            <el-input-number v-model="formData.D" :controls="false" :min="0" :max="99999999" :precision="0" size="small" style="width:80px" @change="countDownChange()"></el-input-number> 天
                            <el-input-number v-model="formData.H" :controls="false" :min="0" :max="23" :precision="0" size="small" style="width:80px" @change="countDownChange()"></el-input-number> 时
                            <el-input-number v-model="formData.S" :controls="false" :min="0" :max="59" :precision="0" size="small" style="width:80px" @change="countDownChange()"></el-input-number> 分
                        </div>
                        <div><small class="color-info">有时效限制，以<span class="color-danger">膨胀活动时效</span>为准，用户在此时间段内可以邀请好友助力</small></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="command" label="活动口令:">
                        <el-input v-model="formData.command" placeholder="自定义活动口令" type="textarea" show-word-limit maxlength="50"></el-input>
                        <div><span class="color-info">生成口令样例：</span>&&****&&{{formData.command}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="rule" label="活动规则:">
                        <tinymce v-model="formData.rule" :height="400" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8"> 
                    <el-form-item prop="launchAccountRule" label="发起活动账号要求:">
                        <el-select v-model="formData.launchAccountRule">
                            <el-option :value="0" label="不限制"></el-option>
                            <el-option :value="1" label="实名认证"></el-option>
                            <!-- <el-option :value="2" label="人脸认证"></el-option> -->
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="joinAccountRule" label="参与活动账号要求:">
                        <el-select v-model="formData.joinAccountRule">
                            <el-option :value="0" label="不限制"></el-option>
                            <el-option :value="1" label="实名认证"></el-option>
                            <!-- <el-option :value="2" label="人脸认证"></el-option> -->
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="joinNum">
                        <span slot="label">可参与活动次数: <small>0表示无限制</small></span>
                        <el-input-number v-model="formData.joinNum" :min="0" :max="99999999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="couponRuleId" label="关联优惠券:">
                        <el-input
                            v-model="formData.couponRuleId"
                            placeholder="请输入优惠券ID"
                            :maxlength="20"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>红包设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="initPriceStr">
                        <span slot="label">初始红包（元）: <small>初始获得红包金额</small></span>
                        <el-input-number v-model="formData.initPriceStr" :min="0" :max="99999999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="limitPriceStr">
                        <span slot="label">红包上限（元）: <small>最大红包金额</small></span>
                        <el-input-number v-model="formData.limitPriceStr" :min="0" :max="99999999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="newUserPriceStr">
                        <span slot="label">新用户助力金额（元）:</span>
                        <el-input-number v-model="formData.newUserPriceStr" :min="0" :max="99999999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="oldUserPriceStr">
                        <span slot="label">老用户助力金额（元）:</span>
                        <el-input-number v-model="formData.oldUserPriceStr" :min="0" :max="99999999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'; 
import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {
    name: "",
    datetimerange: null,
    startTime: null,
    endTime: null,
    rule: "",
    launchAccountRule: 0,
    joinAccountRule: 0,
    joinNum: 1,
    couponRuleId: "",
    initPriceStr: undefined,
    limitPriceStr: undefined,
    newUserPriceStr: undefined,
    oldUserPriceStr: undefined,
    poster: "",
    command:"复制查看",
    countDown: "",
    countDownType: 0,
    D: undefined,
    H: undefined,
    S: undefined
}
export default {
    props:{
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{Tinymce, ImageUpload},
    data(){
        return{
            drawerShow: false,
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            rules: {
                name: [{ required: true, message: "请填写活动名称" }],
                datetimerange: [{ required: true, message: "请填写活动有效期" }],
                couponRuleId: [{ required: true, message: "请填写优惠券ID" }],
                initPriceStr: [{ required: true, message: "请设置初始红包金额" }],
                limitPriceStr: [{ required: true, message: "请设置最大红包金额" }],
                newUserPriceStr: [{ required: true, message: "请设置新用户助力金额" }],
                oldUserPriceStr: [{ required: true, message: "请设置老用户助力金额" }],
                poster:  [{ required: true, message: "请上传活动封面" }],
            },
            toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media'],
            reFresh: false,
            redirect: this.$route.query.redirect || '/promotion/expand/list',
			activityParams:{
			    activityId:'',
			    type:1
			},
			activities:[],
        }
    },
    mounted(){
        if( this.id ){
            this.getDetailData();
        }else{
            this.reFresh = true;
        }
    },
    methods:{
        getDetailData(){
            this.dataLoading = true;
            this.$request({
                url: "/expand/info",
                method: "POST",
                params: {
                    id: this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.formData = {
                        ...defaultFormData,
                        ...result,
                        datetimerange: result.startTime ? [result.startTime,result.endTime] : [],
                        countDownType: result.countDown ? 1 : 0
                    };
                    
                    if( result.countDown ){
                        const seconds = result.countDown;
                       
                        this.formData.D =  Math.floor(seconds / (60 * 60 * 24)) || 0 ;
                        this.formData.H =  Math.floor(seconds / (60 * 60)) - (this.formData.D * 24);
                        this.formData.S = Math.floor(seconds / 60) - (this.formData.D * 24 * 60) - (this.formData.H * 60);
                    }
					this.activities = result.activities ? result.activities :[]
                    this.reFresh = true;
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.dataLoading = false;
			});
        },
		//搜索演出事件
		searchEvent() {
			
		    if (this.activityParams.activityId !== "") {
		        this.dataLoading = true;
		        this.$request({
		            url: "/shop_good/activity",
		            params: this.activityParams,
		            method: "post",
		        })
		            .then((res) => {
		                const { state, result, msg } = res.data;
		                if (state == 1 && result && result.length > 0) {
							this.dataLoading = false;
		                    result.map( item => {
		                        const _obj = this.activities.find(v => v.id == item.id && v.name == item.name);
		                        if(!_obj){
		                            this.activities.push(item);
		                        }
		                    })
		                }else{
		                    this.$message.error(msg || '没有找到相关演出');
							this.dataLoading = false;
		                }
		            })
		    }
		},
		//删除演出
		delActivity(v){
		    this.$confirm('确定要删除吗？', '提示', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.activities =this.activities.filter( item => item !== v);
		    }).catch(() => {})
		},
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess(){
            if(this.formData.poster){
                this.$refs["formData"].clearValidate('poster');
            }
        },
        //时效设置
        countDownChange(){
            const _D = (this.formData.D || 0) * 24 * 60 * 60;
            const _H = (this.formData.H || 0) * 60 * 60;
            const _S = (this.formData.S || 0) * 60;

            this.formData.countDown = _D + _H + _S;
        },
        //表单提交
        submitForm(){
			var _activityIds = []
			if( this.activities && this.activities.length > 0 ){
				this.activities.map( item => {
					_activityIds.push(item.id)
				})
			}
			console.log(_activityIds)
            this.$refs["formData"].validate( (valid) => {
                if (valid) {
                    if( this.formData.limitPriceStr <= this.formData.initPriceStr ){
                        this.$message.error('红包上限金额必须大于初始红包金额');
                        return;
                    }
                    this.btnLoading = true;

                    this.$request({
                        url: '/expand/save',
                        data: {
                            ...this.formData,
                            startTime: this.formData.datetimerange[0],
                            endTime: this.formData.datetimerange[1],
                            countDown: this.formData.countDownType == 1 ? this.formData.countDown : "",
							activityIds:_activityIds.toString()
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>